<template>
	<div class="manage-deal-box-map">
		<GmapMap class="manage-deal-box-map__box" ref="mapRef"
			:center="center"
			:zoom="zoom"
			map-type-id="terrain"
			style="width: 100%; height: 460px;"
			:options="options"
		>
		</GmapMap>
	</div>
</template>

<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import { gmapApi } from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
	load: {
		key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
		libraries: 'places'
	},
	installComponents: true
});

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		details: {
			type: Array,
			required: false
		}
	},
	data: function () {
		return {
			center: { lat: 40.774579546216216, lng: -73.38258752306109 },
			zoom: 9,
			marker: {},
			options: {
				zoomControl: true,
				minZoom: 6,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				disableDefaultUi: false
			}
		};
	},
	computed: {
		google: gmapApi
	},
	methods: {
		setMarker(address) {
			this.$refs.mapRef.$mapPromise.then(map => {
			});			
		},

		removeMarker() {
			this.maker.setMap(null);
		}
	}
};
</script>

<style lang="scss" scoped>
</style>
